import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { AccountType } from "@gtmhub/core";
import { AccountResolverService } from "@gtmhub/state/account-resolver-service";

@Component({
  selector: "feature-banner",
  templateUrl: "./feature-banner.component.html",
  styleUrls: ["./feature-banner.component.less"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FeatureBannerComponent implements OnInit {
  @Input() public hideScale: string;
  @Input() public cssClasses: string;

  public isTrialAccount: boolean;

  constructor(private readonly accountResolverService: AccountResolverService) {}

  public ngOnInit(): void {
    this.isTrialAccount = this.accountResolverService.getAccountData().type === AccountType.TrialAccount;
  }
}
